import Manager from "../../src/manager";
import React from "react";
import Functions from "../../src/functions";

function Mapper(data, status, response, error, component) {
    let output = [];
    return output;
}

function Properties(args) {
    let editable = args.editable ? true : false;
    return {
        id: {
            alias: "id",
            type: "text",
            label: "ID",
            editable: editable,
        },
    };
}


const ErrorPage = {
    auth: "",
    views: {
        list: {
            apis: {
                view: {
                    data: {data: [{}]},
                    replace: {
                    },
                    mapper: Mapper,
                },
            },
            template: "errorPage",
            templateConfiguration: {
                includeProperties: [],
                excludeProperties: [],
                events: { onClick: function (e) {} },
            },
            properties: Properties({ editable: false }),
            primaryKey: "id",
        },
    },
};

export default ErrorPage;
